import styled from 'styled-components';

const MediaContainer = styled.div`
  margin-right: 8px;
  flex: 1 0 auto;
  flex-basis: 40%;
`;

export default MediaContainer;
